import { createSlice } from '@reduxjs/toolkit';

import type { Action, Location } from 'history';
import type { PayloadAction } from '@reduxjs/toolkit';

export type LocationState = {
  location: Location;
  action?: Action;
  protocol?: string;
  isPending: boolean;
};

export type RoutersState = {
  location: LocationState;
  baseUrl: string;
  host: string;
};

const initialLocation: LocationState = {
  location: {
    pathname: '/',
    search: '',
    hash: '',
    state: {},
  },
  isPending: false,
};

const initialState: RoutersState = {
  location: initialLocation,
  baseUrl: '',
  host: '',
};

export const routerSlice = createSlice({
  name: 'router',
  initialState: initialState,
  reducers: {
    locationChangeBegin(state) {
      state.location.isPending = true;
    },
    locationChangeEnd(
      state,
      action: PayloadAction<{ location: Location; action: Action; protocol?: string }>,
    ) {
      state.location = {
        location: action.payload.location,
        action: action.payload.action,
        protocol: action.payload.protocol || state.location.protocol,
        isPending: false,
      };
    },
    setBaseUrl(state, action: PayloadAction<string>) {
      state.baseUrl = action.payload;
    },
    setHost(state, action: PayloadAction<string>) {
      state.host = action.payload;
    },
  },
});

export const { locationChangeBegin, locationChangeEnd, setBaseUrl, setHost } = routerSlice.actions;
export const routerReducer = routerSlice.reducer;
export type RouterState = ReturnType<typeof routerSlice.reducer>;
